// pages/dashboard/Home.jsx (Legacy component - now simplified)
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const HomeDashBoard = () => {
  const navigate = useNavigate();
  const [mode, setMode] = useState(false);

  useEffect(() => {
    const newMode = localStorage.getItem("mode");
    if (newMode) {
      setMode(newMode === "true");
    }
  }, []);

  // Redirect to the new layout structure
  useEffect(() => {
    navigate("/");
  }, [navigate]);

  return (
    <div style={{ background: mode ? "#2D2D30" : "#F7F9FB" }}>
      <div>Redirecting to dashboard...</div>
    </div>
  );
};

export default HomeDashBoard;
